import $ from 'jquery'

// A section of a form that reads as static text until its Edit button is pressed.
//
//   [data-editable-section]  the section, holding exactly one form
//   [data-editable-field]    an input the section may write to; disabled while idle
//   [data-section-edit]      enters edit mode
//   [data-section-cancel]    restores the values the page was loaded with and leaves
//
// Fields without [data-editable-field] stay however the server rendered them, which is
// how a section shows a value it does not own -- see the primary contact on the General
// tab. Disabled inputs are not submitted, so idle sections cannot post anything.

function fields($section) {
  return $section.find('[data-editable-field]')
}

function setEditing($section, editing) {
  fields($section).prop('disabled', !editing)

  $section.find('[data-section-edit]').toggle(!editing)
  $section.find('.issuer-admin-section-controls-editing').toggle(editing)
  $section.toggleClass('is-editing', editing)

  // bootstrap's button-group toggle reads the label, not the radio, so the label needs
  // to look inert too while the section is idle
  $section.find('.btn-group-toggle .btn').toggleClass('disabled', !editing)
}

function snapshot($section) {
  fields($section).each(function () {
    const $field = $(this)

    if (this.type === 'checkbox' || this.type === 'radio') {
      $field.data('initial-checked', this.checked)
    } else {
      $field.data('initial-value', $field.val())
    }
  })
}

function restore($section) {
  fields($section).each(function () {
    const $field = $(this)

    if (this.type === 'checkbox' || this.type === 'radio') {
      this.checked = $field.data('initial-checked')
    } else {
      $field.val($field.data('initial-value'))
    }
  })

  // put bootstrap's active class back on whichever label now holds the checked radio
  $section.find('.btn-group-toggle .btn').each(function () {
    $(this).toggleClass('active', $(this).find('input').prop('checked'))
  })

  $section.find('[data-editable-field]').trigger('change')
}

function initEditableSections() {
  $('[data-editable-section]').each(function () {
    const $section = $(this)

    snapshot($section)
    setEditing($section, false)
  })

  $(document).on('click', '[data-section-edit]', function () {
    setEditing($(this).closest('[data-editable-section]'), true)
  })

  $(document).on('click', '[data-section-cancel]', function () {
    const $section = $(this).closest('[data-editable-section]')

    restore($section)
    setEditing($section, false)
  })
}

document.addEventListener('DOMContentLoaded', initEditableSections)

export default initEditableSections
